export const FREEZONE_TYPES = {
  STATUSFREEZONE: "[STATUS] FREEZONE"
};
